export class Classified {
    static fromExistingData(classfd: any): Classified {
        const classified = new Classified();

        if (classfd.keyTag) classified.keyTag = classfd.keyTag;
        if (classfd.building) classified.buildingId = +classfd.building.bdId;
        if (classfd.building) classified.buildingName = classfd.building.name;
        if (classfd.id) classified.id = +classfd.id;
        if (classfd.otherResident) classified.otherResident = classfd.otherResident;
        if (classfd.otherSuite) classified.otherSuite = classfd.otherSuite;
        if (classfd.resident) classified.residentId = +classfd.resident.bdId;
        if (classfd.resident) classified.residentFullName = classfd.resident.fullName;
        if (classfd.suite) classified.suiteId = +classfd.suite.bdId;
        if (classfd.suite) classified.suiteNumber = classfd.suite.suiteNumber;
        if (classfd.notes) classified.notes = classfd.notes;
        if (classfd.purpose) classified.purpose = classfd.purpose;
        if (classfd.status) classified.status = classfd.status;
        return classified;
    }

    constructor(
        public id: number = null,
        public suiteId: number = null,
        public suiteNumber: string = '',
        public returningByName: string = '',
        public buildingId: number = null,
        public buildingName: string = '',
        public residentId: number = null,
        public residentFullName: string = '',
        public otherResident: string = '',
        public otherSuite: string = '',
        public status: string = '',
        public notes: string = '',
        public purpose: string = '',
        public keyTag: string = '',
        public user: string = '',
        public activityNotes: string = '',
        public playlistId: number = null
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/Classified.ts